import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { RouteUtil } from 'src/app/general/util/route-util';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { BusinessComponent } from '../../components/business/business.component';
import { PageComponent } from '../../components/page/page.component';
import { Util } from 'src/app/general/util/util';

@Component({
  selector: 'app-business-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    BusinessComponent
  ],
  templateUrl: './business-page.component.html',
  styleUrls: ['./business-page.component.css']
})
export class BusinessPageComponent {
  businessId: string;

  constructor(
      private sessionService: SessionService,
      private activatedRoute: ActivatedRoute) {
    this.businessId = '';
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.businessId = Util.safeString(pathParams.get('businessId'));
  }
}
